import React, { useState } from 'react';
import styles from './HelpSupport.module.css';
import {useNavigate, useParams} from "react-router-dom";

export default function HelpSupport({ onBack, onSelectRole, onSkip }) {
  const [selectedRole, setSelectedRole] = useState(null);
  const navigate = useNavigate();

  const handleRoleSelect = (role) => {
    setSelectedRole(role);

    if (onSelectRole) {
      onSelectRole(role);
    }
  };

  return (
    <div className={styles.screenWrapper}>
      <div className={styles.deviceFrame}>

        {/* Decorative Glass Orbs */}
        <div className={styles.glowOrange}></div>
        <div className={styles.glowBlue}></div>

        {/* Fixed Top Bar */}
        <header className={styles.appBar}>
          <button
            type="button"
            className={styles.backBtn}
            onClick={() => navigate(-1)}
            aria-label="Go Back"
          >
            <svg
              width="20"
              height="16"
              viewBox="0 0 24 16"
              fill="none"
              stroke="#005CA9"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M19 8H5" />
              <polyline points="12 1 5 8 12 15" />
            </svg>
          </button>
        </header>

        {/* Scrollable Main Area */}
        <div className={styles.scrollContainer}>
          <main className={styles.contentSection}>

            {/* Brand */}
            <div className={styles.brandContainer}>
              <span className={styles.brandOrange}>Bro</span>
              <span className={styles.brandBlue}>Bizee</span>
            </div>

            {/* Heading */}
            <section className={styles.headingSection}>
              <span className={styles.smallLabel}>SUPPORT CENTER</span>

              <h1 className={styles.pageTitle}>
                Help &amp; Support
              </h1>

              <p className={styles.subtitle}>
                Hello! What can we
                <br />
                help you with?
              </p>
            </section>

            {/* Illustration Glass Card */}
            <div className={styles.illustrationCard}>
              <div className={styles.imageGlow}></div>

              <img
                src="https://img.freepik.com/free-vector/customer-support-flat-illustration_23-2148889374.jpg?w=740"
                alt="Help and Support"
                className={styles.supportImage}
              />

              <div className={styles.supportBadge}>
                <div className={styles.badgeIcon}>
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z" />
                  </svg>
                </div>

                <span>We're here to help</span>
              </div>
            </div>

            {/* Role Selection */}
            <section className={styles.roleSection}>

              <div className={styles.promptHeader}>
                <span className={styles.promptLine}></span>

                <h2 className={styles.promptTitle}>
                  Which one are you?
                </h2>

                <span className={styles.promptLine}></span>
              </div>

              <p className={styles.roleSubtitle}>
                Select your account type to continue
              </p>

              {/* Role Cards */}
              <div className={styles.actionRow}>

                {/* User */}
                <button
                  type="button"
                  className={`${styles.roleBtn} ${
                    selectedRole === 'user'
                      ? styles.activeRole
                      : ''
                  }`}
                  onClick={() => handleRoleSelect('user')}
                >
                  <div className={styles.roleIcon}>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle cx="12" cy="8" r="4" />
                      <path d="M4 21c0-4.4 3.6-7 8-7s8 2.6 8 7" />
                    </svg>
                  </div>

                  <div className={styles.roleContent}>
                    <span className={styles.roleTitle}>User</span>
                    <span className={styles.roleDescription}>
                      Need a service?
                    </span>
                  </div>

                  <div className={styles.arrowCircle}>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="9 18 15 12 9 6" />
                    </svg>
                  </div>
                </button>

                {/* Partner */}
                <button
                  type="button"
                  className={`${styles.roleBtn} ${
                    selectedRole === 'partner'
                      ? styles.activeRole
                      : ''
                  }`}
                  onClick={() => handleRoleSelect('partner')}
                >
                  <div className={styles.roleIcon}>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect
                        x="3"
                        y="7"
                        width="18"
                        height="13"
                        rx="2"
                      />
                      <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                      <path d="M3 12h18" />
                      <path d="M10 12v2h4v-2" />
                    </svg>
                  </div>

                  <div className={styles.roleContent}>
                    <span className={styles.roleTitle}>Partner</span>
                    <span className={styles.roleDescription}>
                      Provide a service
                    </span>
                  </div>

                  <div className={styles.arrowCircle}>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="9 18 15 12 9 6" />
                    </svg>
                  </div>
                </button>

              </div>

              {/* Skip */}
              <button
                type="button"
                className={styles.skipBtn}
                onClick={onSkip}
              >
                <span>Prefer not to choose</span>

                <span className={styles.skipArrow}>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="9 18 15 12 9 6" />
                  </svg>
                </span>
              </button>

            </section>

          </main>
        </div>
      </div>
    </div>
  );
}